import { supabase } from "@/integrations/supabase/client";

export type BackfillRunHistoryRow = {
  id: string;
  function_name: string;
  trigger: "cron" | "manual";
  triggered_by_user_id: string | null;
  status: "succeeded" | "failed";
  scanned_suppressions: number;
  dispatches_updated: number;
  events_appended: number;
  error_count: number;
  error_message: string | null;
  created_at: string;
};

const invokeAdminEmailOps = async (payload: Record<string, unknown>) => {
  const { data, error } = await supabase.functions.invoke("admin-email-ops", {
    body: payload,
  });
  if (error) throw new Error((error as { message?: string }).message ?? "Admin operation failed");
  if (data?.error) throw new Error(data.error);
  return data;
};

export const listBackfillRuns = async (limit = 20): Promise<BackfillRunHistoryRow[]> => {
  const data = await invokeAdminEmailOps({ action: "list_backfill_runs", limit });
  return (data?.runs ?? []) as BackfillRunHistoryRow[];
};

export const runBackfillNow = async (): Promise<{
  ok: boolean;
  status: number;
  result: { scanned_suppressions?: number; dispatches_updated?: number; events_appended?: number; error?: string };
}> => {
  const data = await invokeAdminEmailOps({ action: "run_backfill_now" });
  return {
    ok: !!data?.ok,
    status: typeof data?.status === "number" ? data.status : 0,
    result: (data?.result ?? {}) as {
      scanned_suppressions?: number;
      dispatches_updated?: number;
      events_appended?: number;
      error?: string;
    },
  };
};
